import messagesReducer from "./messagesSlice";
import messageReducer from "./messageSlice";

const customers = {
  messages: messagesReducer,
  message: messageReducer,
};

export default customers;
